export default __webpack_public_path__ + "static/media/404.1f48b1fd.gif";